export const EMIT_MAP = {
  onError: "error",
  onWarning: "warning",
  onDataSynced: "dataSynced",
  onShowToolbar: "showToolbar",
  onReady: "ready",
  onTabGotoBoard: "tabGotoBoard",
  onTabSwitchFile: "tabSwitchFile",
  onScaleBoard: "scaleBoard",
  onCanUndoStatus: "canUndoStatus",
  onCanRedoStatus: "canRedoStatus",
  onRemoveElement: "removeElement",
  onVideoVolumeChanged: "videoVolumeChanged",
  onAddTranscodeFile: "addTranscodeFile",
  onAddH5PPTFile: "addH5PPTFile",
  onH5PPTStatusChanged: "h5PPTStatusChanged",
  onReportLog: "reportLog",
};
